import {Injectable, signal} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    public $$MachineSelector = signal(false);
    public $$openModal = signal(false);
    public $$openHoldConfirmation = signal(false);
    public $$openSummeryModal = signal(false);
    public $$opencreateModal = signal(false);
    public $$openOpeartion = signal(false);
    public $$showFileUploadModal = signal(false);
    public $$showExelUploadModal = signal(false);
    public $$showProcductViewModal = signal(false);
    public $$showProductionDataModal = signal(false);

}